(ns ncr.me
  (:require
   [clojure.string :as str]
   [clojure.core.match :refer [match]]
   [cljs.core.async :as async :refer-macros [go]]
   [uix.core.alpha :as uix]
   [lambdaisland.glogi :as log]
   [ncr.etc.util :as u]
   [ncr.widgets.core :as w]
   [ncr.backend :as b]
   [ncr.auth :as a]
   [ncr.etc.pubsub :as ps]
   [ncr.push :as push]))

(uix/defcontext *context*)

(defn c-no-account-page []
  (let [{:keys [email]} (uix/context a/*context*)]
    [:div.pf-c-login
     {:style
      {:background :#000
       :background-position :center
       :background-size :auto}}
     [:div.pf-c-login__container
      [:main.pf-c-login__main
       [:header.pf-c-login__main-header
        [:h1.pf-c-title.pf-m-3xl "Account not registered"]
        [:p.pf-c-login__main-header-desc
         "There is no account associated with " [w/c-strong email] " email address. "
         "Please contact the responsible administrator."]]
       [:div.pf-c-login__main-body]
       [:footer.pf-c-login__main-footer
        [:div.pf-c-login__main-footer-band]]]]]))

(defn- index-me [me]
  (merge me
    {::label-by-id
     (u/index-by :id (get-in me [:cluster :labels]))

     ::label-by-name
     (u/index-by :name (get-in me [:cluster :labels]))

     ::folder-by-id
     (u/index-by :id (get-in me [:folders]))

     ::user-by-id
     (u/index-by :id (get-in me [:cluster :users]))}))

(defn label-by-id [me id]
  (get-in me [::label-by-id id]))

(defn label-by-name [me nm]
  (get-in me [::label-by-name nm]))

(defn folder-by-id [me id]
  (get-in me [::folder-by-id id]))

(defn user-by-id [me id]
  (get-in me [::user-by-id id]))

(defn shared-folders [{:keys [folders]}]
  (filter
    (fn [{:keys [folderType]}]
      (= folderType "SHARED"))
    folders))

(defn inbox-folder [{:keys [folders]}]
  (->> folders
    (filter
      (fn [{:keys [folderType]}]
        (= folderType "INBOX")))
    (first)))

(defn trash-folder [{:keys [folders]}]
  (->> folders
    (filter
      (fn [{:keys [folderType]}]
        (= folderType "TRASH")))
    (first)))

(defn- use-capabilities []
  (let [caps
        (ps/sub-reducer-map! {:status :loading}
          {:me/set-caps #(do %2)
           :me/load-caps
           (fn [state]
             (go
               (let
                 [datev
                  (<! (b/!query [:datev_status [:status :sandbox :data]]))]
                 (log/debug :request :datev :response datev)

                 (ps/pub!
                   [:me/set-caps
                    (u/if-ok [datev datev]
                      {:status :loaded
                       :datev
                       {:status (-> datev :status str/lower-case keyword)
                        :allowed true}}
                      {:status :error :error datev})])))
             state)})]
    (uix/with-effect []
      (ps/pub! [:me/load-caps]))
    caps))

(defn c-with-me [body]
  (let
    [me
     (ps/sub-reducer-map! [:error :waiting]
       {::set
        (fn [_ value]
          value)

        :me/load
        (fn [state]
          (go
            (let
              [me
               (<!
                 (b/!query
                   [:me
                    [:name :email :id :roles
                     [:cluster
                      [:id :name :slug :type
                       [:labels [:id :name]]
                       [:users [:id :name :email :picture :isManager :active]]]]
                     [:folders [:id :name :folderType :access :fragmentCount]]]]))]
              (log/debug :request :me :response me :folders (->> me :folders (map :folderType)))

              (ps/pub!
                [::set
                 (u/if-ok [me me]
                   [:ok
                    (-> me
                      (update :roles #(map keyword %))
                      (update :roles set))]
                   [:error :noaccount])])))
          state)

        ::set-folder-counts
        (fn [[_ state] folder-counts]
          [:ok
           (update state :folders
             (fn [folders]
               (vals
                 (reduce
                   (fn [acc {:keys [id fragmentCount]}]
                     (assoc-in acc [id :fragmentCount] fragmentCount))
                   (u/index-by :id folders)
                   folder-counts))))])})
     caps (use-capabilities)]

    (push/use-push!
      (fn [message]
        (go
          (match message
            {:domain :reference :event-type (:or :create :update)}
            (let
              [{:keys [folders]}
               (<!
                 (b/!query
                   [:me
                    [[:folders [:id :fragmentCount]]]]))]
              (ps/pub! [::set-folder-counts folders]))

            _
            nil))))


    (uix/with-effect []
      (ps/pub! [:me/load]))

    (match @me
      [:error :waiting]
      [w/c-bare-status "Loading..."]

      [:error :noaccount]
      [c-no-account-page]

      [:ok me']
      (uix/context-provider [*context* (assoc (index-me me') :caps @caps)]
        body))))
